import { useDispatch, useSelector } from "react-redux";
import {
  getDestination,
  getSortOption,
  getTripCategory,
  setSortOption,
} from "@b2bportal/core-flights";
import { useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type SortOptionEnum,
  TripCategory,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { FilterDialog, FlightListGridFilter, Sort } from "@tenant/flights";
import styles from "./styles.module.scss";

export const Filters = ({ sliceIndex }) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, CoreFlightsComponent.Filters);

  const dispatch = useDispatch();
  const destination = useSelector(getDestination);
  const sortOption = useSelector(getSortOption);
  const tripCategory = useSelector(getTripCategory);
  const handleSortChange = (value: string) => {
    dispatch(setSortOption(value as SortOptionEnum));
  };

  return (
    <div className={block}>
      <div className={cn("header")}>
        <span className={cn("title")}>
          {t("filtersHeader.title", { destination: destination?.label || "" })}
        </span>
        <span className={cn("subtitle")}>
          {tripCategory === TripCategory.ROUND_TRIP
            ? t("filtersHeader.roundTripSubtitle")
            : t("filtersHeader.oneWaySubtitle")}
        </span>
      </div>

      <span className={cn("openFilters")}>
        <FilterDialog sliceIndex={sliceIndex} />
      </span>

      <span className={cn("recommend")}>
        <Sort
          className={cn("sort-content")}
          value={sortOption}
          handleSortChange={handleSortChange}
        />
      </span>

      <div className={cn("fareFilters")}>
        <FlightListGridFilter className={cn("gridList")} />
      </div>
    </div>
  );
};
